import React from "react";
import { Link } from "react-router-dom";
import aboutImg from "../assets/images/features/about-4.png"

import {FiCheckCircle, MdKeyboardArrowRight} from '../assets/icons/vander'

export default function AboutFour(){
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
            <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                <div className="relative overflow-hidden rounded-lg  ps-6 pt-6 lg:me-8">
                    <img src={aboutImg} className="ltr:rounded-tl-lg rtl:rounded-tr-lg" alt=""/>
                </div>

                <div className="">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Join a Thriving Community of AI Innovators</h3>
                    <p className="text-slate-400 max-w-xl">Being part of our marketplace means more than just listing your product — it’s about joining a dynamic network of AI leaders, innovators, and enthusiasts.</p>

                    <ul className="list-none text-slate-400 mt-4">
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Connect with Industry Experts</li>
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Collaborate & Grow Together</li>
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Contribute to the Future of AI</li>
                    </ul>

                   
                </div>
            </div>
        </div>
        </>
    )
}